import { useEffect } from 'react';
import company from '../data/company';

const setMeta = (name, content) => {
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

/**
 * Управляет заголовком вкладки и описанием страницы.
 *
 * @param {object} props
 * @param {string} [props.title] — без названия компании, оно добавляется само
 * @param {string} props.description
 */
function PageMeta({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} — ${company.fullName}` : company.fullName;
    if (description) setMeta('description', description);
  }, [title, description]);

  return null;
}

export default PageMeta;
